/**
 * Created by Victor Rojo on 2/4/19.
 */
import {Component, Input, OnDestroy, ViewChild, ElementRef,
        AfterContentInit, HostListener, Renderer2} from '@angular/core';
import {CameraWidget} from "../../widget/Widget";
import {WidgetStatusChangeAware} from "../base-widget/WidgetStatusChangeAware";
import {IPlaceDataChangeService} from "../../IPlaceDataChange.service";

import { interval ,  Unsubscribable as AnonymousSubscription }             from "rxjs";

import * as Videojs from "video.js";

@Component({
  selector: 'hls-camera',
  templateUrl: './HLSCamera.component.html',
  styleUrls: ['./HLSCamera.component.css']
})
export class HLSCameraComponent extends WidgetStatusChangeAware{


  src = "";
  _camera: CameraWidget;
  isLoading = true;
  attempt = 1;
  maxAttempts = 5;
  isFullscreen = false;
  selected:any = null;
  player:any;
  @ViewChild('video', { static: true }) video: ElementRef;
  private interval: AnonymousSubscription;
  private curentTime: number;
  private curentTimeCheck: number;

  private retryTimeout:any;

  constructor(private iPlaceDataChangeService1: IPlaceDataChangeService,
              private renderer: Renderer2) {
    super(iPlaceDataChangeService1);
    this.interval = interval(10000).subscribe(() => {
      if ( this._streamingActive && this.player
          && this.player.tech({ IWillNotUseThisInPlugins: true }
          && this.player.tech({ IWillNotUseThisInPlugins: true }).hls )) {
        let playerCurrentTime = this.player.tech({ IWillNotUseThisInPlugins: true }).hls.stats.currentTime;
        if ( this.curentTime !=  playerCurrentTime ) {
          this.curentTime =  playerCurrentTime;
          this.attempt = 1;
          this.curentTimeCheck = new Date().getTime();
        } else if ( !this.isLoading && this.attempt < this.maxAttempts && new Date().getTime() - this.curentTimeCheck > 20000) {
          this.selectStreaming(this.selected);
        }
      }
    });
  }

  get camera(): CameraWidget {
    return this._camera;
  }

  @Input()
  set camera(camera: CameraWidget) {
    this._camera = camera;
    this.startStreaming();
  }

  private _streamingActive = true;

  public streamingActive(active: boolean) {
    if ( active && !this._streamingActive ) {
      this.startStreaming();
      this._streamingActive = true;
    } else if ( !active && this._streamingActive ) {
      this.cancelStreaming();
      this.isLoading = false;
      this._streamingActive = false;
    }
  }

  private startStreaming() {
    let id = "player" + this._camera.widgetId;
    let video = this.renderer.createElement('video');
    this.renderer.setAttribute(video, "id", id);
    this.renderer.appendChild(this.video.nativeElement, video);
    let videojs = Videojs.default;
    this.player = videojs(id, {
      autoplay: 'muted',
      children: []
    });
    var self = this;
    this.player.on("loadedmetadata", function(){
      self.isLoading = false;
    });
    this.updateStreamingList();
  }

  private updateStreamingList() {
    this.src = "";
    if ( this._camera.cameras && this._camera.cameras.length ) {
      let camera = this.selected ? this.selected : this._camera.cameras[0];
      this.selectStreaming(this._camera.cameras[0]);
    } else {
      this.isLoading = false;
    }
  }

  selectStreaming(camera:any) {
    this.isLoading = true;
    this.attempt = 1;
    this.curentTime = 0;
    this.curentTimeCheck = 0;

    this.src = "api/v1/camera/" + camera.cameraId + "/playlist.m3u8";

    this.player.src({
      src: this.src,
      type: 'application/x-mpegURL'
    });
    this.selected = camera;
    this.retryIfNotLoaded();
  }

  manualReconnect(){
    this.selectStreaming(this.selected);
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if ( this.isFullscreen ) {
      this.setFullscreen(false);
    }
  }

  retryIfNotLoaded() {
    if ( this.retryTimeout != null ) {
      clearTimeout(this.retryTimeout);
      this.retryTimeout = null;
    }
    this.retryTimeout = setTimeout(()=>{
      this.retryTimeout = null;
      if ( this.isLoading && this.attempt < this.maxAttempts) {

        this.player.src({
          src: this.src,
          type: 'application/x-mpegURL'
        });

        this.attempt++;
        this.retryIfNotLoaded();
      } else if ( this.attempt >= this.maxAttempts ) {
        this.isLoading = false;
      }
    }, 5000);
  }

  setFullscreen(value:boolean){
    this.isFullscreen = value;
  }

  snapshot(){
    if ( !this.isLoading ) {
      var c = document.createElement('canvas');
      let videoElement = this.player.$("video");

      c.width = videoElement.videoWidth;
      c.height = videoElement.videoHeight;
      var ctx = c.getContext('2d');

      ctx.drawImage(videoElement, 0, 0);

      var link = document.createElement('a');
      link.setAttribute('download', this.selected.name + new Date().toLocaleString() + '.png');
      link.setAttribute('href', c.toDataURL("image/png").replace("image/png", "image/octet-stream"));
      link.click();
    }
  }

  cancelStreaming(){
    if ( this.player ) {
      this.player.dispose();
    }
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
    this.cancelStreaming();
    if ( this.interval ) {
      this.interval.unsubscribe()
    }
  }
}
